import { AxiosRequestConfig } from 'axios';
import { ErrorResponse } from '../../../lib/basicRepository';
import {
  CustomerToCopy,
  OnConfirmData,
} from '../../../modules/orders/copy-order/types/copyOrderModal.types';
import { ConditionValidationErrors, Order } from '../../../modules/orders/order.types';
import { PaginatedResponse } from '../../../types/request.types';
import { restApi } from '../../api';
import getRoutePrefix from '../../utils/getRoutePrefix.util';
import {
  FindCustomersToCopyParams,
  FindOrdersCountOutput,
  FindOrdersCountParams,
  FindSimpleOrdersListOutput,
  FindSimpleOrdersListParams,
  GetMaxSubtotalOutput,
  IConfirmAcceptOrderRequest,
  SendOfflineOrderToSyncInput,
  ValidateSyncStatusOfOrdersInput,
  ValidateSyncStatusOfOrdersOutput,
} from './orders.types';

const PATH = 'orders';

export const findOrdersCount = (params: FindOrdersCountParams) =>
  restApi.get<FindOrdersCountOutput>(`${getRoutePrefix()}/orders-list/count`, params);

export const PATH_TO_SYNC_OFFLINE_ORDER = `${PATH}/offline/sync`;
export const PATH_TO_VALIDATE_SYNC_STATUS_OF_ORDERS = `${PATH}/offline/sync/status`;

export const findCustomersToCopy = (params: FindCustomersToCopyParams) =>
  restApi.get<PaginatedResponse<CustomerToCopy>>(`${PATH}/info/customers-to-copy`, params);

export const findSimpleOrdersList = (params: FindSimpleOrdersListParams) =>
  restApi.get<FindSimpleOrdersListOutput>(`${PATH}/simple`, params);

export const getMaxSubtotal = () =>
  restApi.get<GetMaxSubtotalOutput>(`${getRoutePrefix()}/${PATH}/max-subtotal`);

export const copyOrder = (data: OnConfirmData, axiosConfig: AxiosRequestConfig, orderId?: string) =>
  restApi.post<void, ErrorResponse>(
    `/${PATH}/${orderId}/copy`,
    {
      gridMultiplier: data.gridMultiplier,
      copyOrderWithConditions: data.copyOrderWithConditions,
      asSuggested: data.asSuggested,
      customerIds: data.customerGroups?.length
        ? data.customerGroups?.map((item: any) => item?.id)
        : undefined,
    },
    axiosConfig,
  );

export const acceptSuggestion = (data: IConfirmAcceptOrderRequest, orderId?: string) =>
  restApi.post<
    void,
    {
      message: ConditionValidationErrors;
    }
  >(`/${PATH}/${orderId}/accept-suggestion`, data);

export const sendOfflineOrderToSync = (data: SendOfflineOrderToSyncInput) =>
  restApi.post<Order, ErrorResponse>(PATH_TO_SYNC_OFFLINE_ORDER, data);

export const validateSyncStatusOfOrders = (input: ValidateSyncStatusOfOrdersInput) =>
  restApi.get<ValidateSyncStatusOfOrdersOutput>(PATH_TO_VALIDATE_SYNC_STATUS_OF_ORDERS, input);

export const logOfflineOrder = (data: SendOfflineOrderToSyncInput) =>
  restApi.post<Order>(`${PATH}/offline/log`, data);
